import * as React from 'react';

import { Routes, Route } from 'react-router-dom';

import RequireAuth from '../../components/RequireAuth';

import { ReportType } from '../../core/api/clients';
import { useAppData } from '../../core/context/AppDataContext';
import { AuthorizedFormDataProvider } from '../../core/context/AuthorizedFormDataContext';

import LoadingOverlay from '../../components/LoadingOverlay';
import CabinEventFormLayout from './CabinEventFormLayout';
import CabinEventHome from './CabinEventHome';
import CabinEventFormNew from './CabinEventFormNew';
import CabinEventFormEdit from './CabinEventFormEdit';
import CabinEventFormView from './CabinEventFormView';
import useTitle from '../../core/api/hooks/common/useTitle';

function CabinEventContainer() {
  const { authorizedForms, getFormByName } = useAppData();
  useTitle(document.documentURI);
  if (authorizedForms !== undefined) {
    const form = getFormByName(ReportType.CabinEventReport);

    if (form !== undefined) {
      const { isContributor, isAdministrator, isReader, isApprover } = form;

      const canEdit = (isContributor || isApprover || isAdministrator);
      const canView = (isReader || canEdit);

      return (
        <AuthorizedFormDataProvider authorizedFormData={form}>
          <Routes>
            <Route path=":formId" element={<CabinEventFormLayout />}>
              <Route
                path="edit"
                element={(
                  <RequireAuth isAuthorized={canEdit ?? false}>
                    <CabinEventFormEdit />
                  </RequireAuth>
                )}
              />
              <Route
                path=":action"
                element={(
                  <RequireAuth
                    isAuthorized={canView ?? false}
                  >
                    <CabinEventFormView />
                  </RequireAuth>
                )}
              />
            </Route>
            <Route
              path="new"
              element={(
                <RequireAuth isAuthorized={form.isContributor ?? false}>
                  <CabinEventFormNew />
                </RequireAuth>
              )}
            />
            <Route
              index
              element={(
                <CabinEventHome />
              )}
            />
          </Routes>
        </AuthorizedFormDataProvider>
      );
    }

    return (
      <span>Not Authorized</span>
    );
  }

  return (
    <LoadingOverlay />
  );
}

export default CabinEventContainer;
